module.exports = __webpack_public_path__ + "static/media/search.efefe146.svg";